import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DisplayText } from "../../../DisplayText";
import * as S from "../../Form.styled";
export var ObjectFieldTemplate = function (props) {
    var title = props.title, description = props.description, properties = props.properties, className = props.className;
    return (_jsxs(S.Fieldset, { className: className, children: [title && _jsx(DisplayText, { size: "medium", children: title }), description && _jsx("p", { children: description }), properties.map(function (element) { return element.content; })] }));
};
